<template>
  <div :id="'chapter_' + chapter.chapterNumber" class="chapter hide">
    <div class="mx-5 my-3 content"></div>
  </div>
</template>

<script>
export default {
  name: "br-pages",
  data() {
    return {
      str: "",
    };
  },
  props: {
    resource_dir: {
      type: String,
      defaul: "",
    },
    chapter: {
      type: Object,
      defaul: {},
    },
  },
  mounted() {
    let url = `https://assets.beereaders.com/lbr/book/${
      this.resource_dir
    }/c_${this.pad(this.chapter.chapterNumber, 2)}.html`;
    this.getChapter(this, url);
  },
  methods: {
    pad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    async getChapter(vm, url) {
      try {
        let { data } = await this.axios.get(url);
        document.getElementById(
          `chapter_${this.chapter.chapterNumber}`
        ).childNodes[0].innerHTML = data;
      } catch {
        // this.getBooksList();
      } finally {
        // do something
      }
    },
  },
};
</script>

<style lang="css">
.chapter_title {
  font-size: 3rem;
  font-weight: bold;
  padding-top: 5vh;
  border-bottom: 1px #9d9ba6 solid;
  margin-bottom: 1em;
  text-align: center;
}
</style>
